module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/one-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0 0 0",
      "overflow": "hidden"
    },
    style: ({
      height: _vm.isExpand ? '' : '25px'
    })
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "absolute",
      "bottom": "-25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    style: ({
      transform: _vm.isExpand ? '' : 'rotate(180deg)'
    }),
    attrs: {
      "src": require("../../../common/images/arrow.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isExpand = !_vm.isExpand
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      自然人投资者中的专业投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、身份证正反面照片（或扫描件）；\n        "), _c('br'), _vm._v("\n        2、最近3年个人年均收入不低于50万元的个人收入证明，或者不低于500万元的金融资产*证明；\n        "), _c('br'), _vm._v("\n        3、2 年以上证券、基金、期货、黄金、外汇等投资经历证明，或者或属于经有关金融监管部门批准设立的金融机构（包括证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司等），经行业协会备案或者登记的证券公司子公司、期货公司子公司、私募基金管理人的高级管理人员、获得职业资格认证的从事金融相关业务的注册会计师和律师等的资格证明；\n        "), _c('br'), _vm._v("\n        4、投资者基本信息表（自然人）相关信息；\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n          金融资产证明文件可以参考以下证明: "), _c('br'), _vm._v("\n          ①银行存款，银行出具的存款证明；  "), _c('br'), _vm._v("\n          ②股票，证券账户内股票市值；"), _c('br'), _vm._v("\n          ③债券，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ④基金份额，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑤资产管理计划，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑥银行理财产品，银行出具的资产证明；"), _c('br'), _vm._v("\n          ⑦信托计划，购买合同；"), _c('br'), _vm._v("\n          ⑧保险产品，购买合同；"), _c('br'), _vm._v("\n          ⑨期货，申请日前一交易日客户权益；"), _c('br'), _vm._v("\n          ⑩其他衍生品，购买凭证；"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": require("../../../common/images/share-download.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585c0644"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/page/two.vue
// module id = 1055
// module chunks = 1